import { useCallback } from "react";

import type * as FormModelType from "@/components/features/settings/payment-deposit-account/model/type";

export const usePaymentDepositAccountForm = (
	viewModel: FormModelType.PaymentDepositAccountFormModel["ViewModel"],
	onSetViewModel: (viewModel: FormModelType.PaymentDepositAccountFormModel["ViewModel"]) => void,
) => {
	const onChangeMinimumTransferAmount = useCallback(
		(value: number) => {
			onSetViewModel({
				...viewModel,
				minimumTransferAmount: {
					...viewModel.minimumTransferAmount,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const onChangeBankCode = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				bankCode: {
					...viewModel.bankCode,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const onChangeBankBranchCode = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				bankBranchCode: {
					...viewModel.bankBranchCode,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const onChangeBankAccountType = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				bankAccountType: {
					...viewModel.bankAccountType,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const onChangeBankAccountNumber = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				bankAccountNumber: {
					...viewModel.bankAccountNumber,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const onChangeBankAccountHolderName = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				bankAccountHolderName: {
					...viewModel.bankAccountHolderName,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	return {
		onChangeMinimumTransferAmount,
		onChangeBankCode,
		onChangeBankBranchCode,
		onChangeBankAccountType,
		onChangeBankAccountNumber,
		onChangeBankAccountHolderName,
	};
};
